import { LAYERS, SlotSettings} from '@gongxigames/framework/slot';
import {GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';
import {SlotModuleV2} from '@gongxigames/framework/slotV2/baseClasses/slotModuleV2/SlotModuleV2';
import {AnticipatorViewV2} from '@gongxigames/framework/slotV2/modules/anticipator/AnticipatorViewV2';

export class AnticipatorModuleV2<T extends GameOnlyEventMap> extends SlotModuleV2<T>{
    public static readonly NAME: symbol = Symbol('AnticipatorModule');
    public static layer = LAYERS.POPUPS;

    protected _settings?: SlotSettings;

    public static readonly SOUND_NAME: string = 'hyperspin';

    protected view!: AnticipatorViewV2;

    protected onInit(): void {
        this.view = new AnticipatorViewV2({
            onStarted: this.onAnticipationAnimationStarted.bind(this),
            onFinished: () => {}
        });
        this.container.addChild(this.view.container);
    }

    protected onSetupEvents(): void {
        super.onSetupEvents();

        this.emitter.on('General.Reels.AllReelsStopped', this.onSpinEnded.bind(this));
        this.emitter.on('General.Reels.ReelsQuickStopStarted', this.onQuickStoppingInitiated.bind(this));
        this.emitter.on('General.Reels.WaitAnticipation', this.waitAnticipation.bind(this));
    }

    protected waitAnticipation(reelIndex: number): Promise<void> {
        return this.view.play(reelIndex + 1);
    }

    protected onAnticipationAnimationStarted(): void {
        this.store.soundPlayer.value!.play(AnticipatorModuleV2.SOUND_NAME);
    }

    protected onQuickStoppingInitiated(): void {
        this.stopAnticipationAnimation();
    }

    protected onSpinEnded(): void {
        this.stopAnticipationAnimation();
    }

    protected stopAnticipationAnimation(): void {
        this.store.soundPlayer.value!.stop(AnticipatorModuleV2.SOUND_NAME);
        this.view.stopAnticipationAnimation();
    }
}
